import {
  collectionGroup,
  onSnapshot,
  query,
  where,
  Query,
} from 'firebase/firestore';
import { firestore } from 'src/config/firebaseClient';
import { toCheckInProps } from 'src/util/tournaments/toCheckInProps';
import { isNotCheckedIn } from 'src/util/tournaments/isNotCheckedIn';
import { useAuth } from 'src/contexts/AuthContext';
import { useState, useEffect } from 'react';
import { Tournament } from 'functions/src/types/firestore/Game/Tournament';
import { ConverterFactory } from 'functions/src/util/firestore/ConverterFactory';
import { useCheckInDialog } from 'src/components/tournaments/check-in/useCheckInDialog';



export const useTournamentCheckIn = () => {
  const { user } = useAuth();
  const { open: openCheckInDialog } = useCheckInDialog();
  const [tournamentsNotCheckedIn, setTournamentsNotCheckedIn] =
    useState<Tournament<Date>[]>();
  
  useEffect(() => {
    if (!user) {
      setTournamentsNotCheckedIn(undefined);
      return;
    }

    const tournamentQuery = query(
      collectionGroup(firestore, `Tournament`),
      where('phase', '==', 'checkIn'),
    ).withConverter(
      ConverterFactory.buildDateConverter<Tournament<Date>>(),
    ) as Query<Tournament<Date>>;

    const unsubscribe = onSnapshot(tournamentQuery, (tournamentSnapshots) => {
      const tournamentsArray: Tournament<Date>[] = tournamentSnapshots.docs.map(
        (doc) => {
          return doc.data();
        },
      );
      const activeUserTournaments = tournamentsArray.filter((tournament) => {
        return isNotCheckedIn(tournament, user.uid);
      });
      setTournamentsNotCheckedIn(activeUserTournaments);
    });

    return unsubscribe;
  }, [user]);

  const tournamentsActiveOrdered = tournamentsNotCheckedIn?.sort((a, b) => {
    return a.date.getTime() - b.date.getTime();
  });

  const checkInProps = tournamentsActiveOrdered?.length
    ? toCheckInProps(tournamentsActiveOrdered[0], user?.uid)
    : undefined;

  useEffect(() => {
    if (!!checkInProps && !checkInProps.skipCheckIn) {
      openCheckInDialog({ ...checkInProps, preventBackdropClick: true });
    }
  }, [tournamentsNotCheckedIn, checkInProps, openCheckInDialog]);
};
